import clipToNormalizedMaxLength from "@next-platform/client-common-core/utils/clipToNormalizedMaxLength";

import sanitizeWhitespace from "./sanitizeWhitespace";

export default function applyNormalizedFieldChange({
  inputValue,
  maxLength,
  onChange,
}: {
  inputValue: string;
  maxLength?: number;
  onChange: (...event: unknown[]) => void;
}) {
  const nextValue = maxLength ? clipToNormalizedMaxLength({ value: inputValue, maxLength }) : inputValue;
  sanitizeWhitespace(onChange)(nextValue);
}
